module.exports = __webpack_public_path__ + "media/icons/ubezpieczenia-menu@2x-9dd17e3a.png";